import { SCRIPTS_ELEMENT_DATA_NAME, ScriptStatuses } from './loadCrossTabMessaging';
export const getDependencyStatus = () => {
  const script = document.querySelector(`script[data-name="${SCRIPTS_ELEMENT_DATA_NAME}"]`);
  if (!script) {
    return ScriptStatuses.unknown;
  }
  const status = script.getAttribute('data-status');
  return status || ScriptStatuses.unknown;
};